module.exports = __webpack_public_path__ + "static/media/melissa5.413d1adb.jpg";